import { cn } from '@/lib/utils'

interface RankItemProps {
  rank: number
  nickname: string
  value: number
  unit: string
  maxValue?: number
  isSelf?: boolean
}

export function RankItem({ rank, nickname, value, unit, maxValue, isSelf }: RankItemProps) {
  const percentage = maxValue ? Math.round((value / maxValue) * 100) : 100

  const getRankStyle = () => {
    if (rank === 1) return { bg: 'bg-gradient-to-r from-amber-400 to-yellow-500', text: 'text-white', badge: '👑' }
    if (rank === 2) return { bg: 'bg-gradient-to-r from-gray-300 to-gray-400', text: 'text-white', badge: '🥈' }
    if (rank === 3) return { bg: 'bg-gradient-to-r from-amber-600 to-amber-700', text: 'text-white', badge: '🥉' }
    return { bg: 'bg-muted', text: 'text-foreground', badge: '' }
  }

  const style = getRankStyle()

  const formatValue = (v: number, u: string) => {
    if (u === '小时') {
      const h = Math.floor(v / 3600)
      const m = Math.floor((v % 3600) / 60)
      return h > 0 ? `${h}小时${m}分钟` : `${m}分钟`
    }
    return `${v}${u}`
  }

  return (
    <div className={cn(
      'flex items-center gap-3 py-3 px-4 rounded-xl transition-colors',
      isSelf && 'bg-primary/5 border border-primary/20'
    )}>
      {/* Rank badge */}
      <div className={cn(
        'w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-sm font-bold',
        style.bg, style.text,
        rank > 3 && 'bg-muted text-muted-foreground'
      )}>
        {rank <= 3 ? style.badge : rank}
      </div>

      {/* Name and progress */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <span className={cn(
            'text-sm font-medium truncate',
            isSelf && 'text-primary'
          )}>
            {nickname || '我'}
          </span>
          <span className="text-sm font-semibold tabular-nums shrink-0 ml-2">
            {formatValue(value, unit)}
          </span>
        </div>
        {maxValue && rank <= 3 && (
          <div className="h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className={cn('h-full rounded-full transition-all duration-500', style.bg)}
              style={{ width: `${percentage}%` }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
